import { forwardRef } from "react";

import type {
  TTableSectionProps,
} from "@/ui/components/data-display/Table/Table.config";
import { cn } from "@/ui/lib/utils";

export const TBody = forwardRef<HTMLTableSectionElement, TTableSectionProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <tbody
      {...props}
      ref={ref}
      data-component="TBody"
      className={cn(className)}
    />
  ),
);

TBody.displayName = "TBody";
